import { CommunityFeed } from '@/types'
import { RenderItemProps } from './types'

import { FeedImage } from './Image'
import { FeedText } from './Text'
import { FeedStory } from './Story'
import { FeedVideo } from './Video'
import { FeedLesson } from './Lesson'
import { FeedReviewQuestion } from './ReviewQuestion'
import { FeedReview } from './Review'
import { FeedPrompt } from './Prompt'
import { FeedHurdle } from './Hurdle'
import { FeedBetaGame } from './BetaGame'
import { ProfileQuestions } from './ProfileQuestions'

export const feedItemsByType: Record<CommunityFeed['type'], React.ComponentType<RenderItemProps>> = {
  video: FeedVideo,
  text: FeedText,
  image: FeedImage,
  lesson: FeedLesson,
  prompt: FeedPrompt,
  review: FeedReview,
  review_question: FeedReviewQuestion,
  story: FeedStory,
  image_answer: FeedImage,
  text_answer: FeedText,
  video_answer: FeedVideo,
  hurdle: FeedHurdle,
  game: FeedBetaGame,
  profile_prompt: ProfileQuestions,
}